/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createSplitGetResponseFromDiscriminatorValue, serializeSplitPostRequest, type SplitGetResponse, type SplitPostRequest } from '../../../models';
// @ts-ignore
import { type WithSplitItemRequestBuilder, WithSplitItemRequestBuilderNavigationMetadata, WithSplitItemRequestBuilderRequestsMetadata } from './item';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /accounts/{accountId}/splits
 */
export interface SplitsRequestBuilder extends BaseRequestBuilder<SplitsRequestBuilder> {
    /**
     * Gets an item from the MoneyChecker.Web.ApiClient.accounts.item.splits.item collection
     * @param splitId Unique identifier of the item
     * @returns {WithSplitItemRequestBuilder}
     */
     bySplitId(splitId: Guid) : WithSplitItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SplitGetResponse[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SplitGetResponse[] | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Guid>}
     */
     post(body: SplitPostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Guid | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: SplitPostRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SplitsRequestBuilderUriTemplate = "{+baseurl}/accounts/{accountId}/splits";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const SplitsRequestBuilderNavigationMetadata: Record<Exclude<keyof SplitsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    bySplitId: {
        requestsMetadata: WithSplitItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithSplitItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["splitId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const SplitsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: SplitsRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createSplitGetResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: SplitsRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "string",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSplitPostRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
